import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classnames from 'classnames'
import { fetchStudents, fetchStudentsAttendence, fetchDailyReport } from '../../redux/action/facultyAction'
import FacultyHomeHelper from '../../Components/FacultyHomeHelper'
import { useHistory, Link } from 'react-router-dom'


const AttendenceFaculty = () => {
    const store = useSelector((store) => store)
    const history = useHistory()
    const dispatch = useDispatch("")
    const [year, setYear] = useState("")
    const [section, setSection] = useState("")
    const [semester, setSemester] = useState("")
    const [date, setDate] = useState("")
    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [totalPresent, setTotalPresent] = useState(0);
    const [totalAbsents, setTotalAbsents] = useState(0);
    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])
    const department = store.faculty.faculty.faculty.department;
    const formHandler = (e) => {
        e.preventDefault();
        setIsLoading(false); // Clear previous loading state
        setIsLoading(true);
        dispatch(fetchStudents(department, year, section, semester))
            .finally(() => {
                setIsLoading(false);
            });
    };
    useEffect(() => {
        if (store.error || !store.faculty.fetchedStudentsHelper) {
            setIsLoading(false);
        }
    }, [store.error, store.faculty.fetchedStudentsHelper]);

    // Reset loading state when the parameters for fetchStudents change
    useEffect(() => {
        setIsLoading(false);
    }, [department, year, section, semester]);


    const secondFormHandler = (e) => {
        e.preventDefault();
        setIsLoading2(true);
        dispatch(fetchDailyReport(department, year, section, semester, date))
        dispatch(fetchStudentsAttendence(department, year, section, semester, date))
            .finally(() => {
                setIsLoading2(false);
            });
    };


    useEffect(() => {
        if (store.faculty.fetchedStudentsHelper) {
            setIsLoading2(false);
        }
    }, [store.faculty.fetchedStudentsHelper]);

    useEffect(() => {
        // Check if fetchedStudentsAttendance is defined and has the expected structure
        if (store.faculty.fetchedStudentsAttendence && Array.isArray(store.faculty.fetchedStudentsAttendence.data)) {
            const data = store.faculty.fetchedStudentsAttendence.data[0]?.departments[0]?.years[0]?.semesters[0]?.sections[0]?.students;

            if (Array.isArray(data)) {
                const totalPresentCount = data.filter((student) => student.status === 'Present').length;
                const totalAbsentCount = data.filter((student) => student.status === 'Absent').length;

                setTotalPresent(totalPresentCount);
                setTotalAbsents(totalAbsentCount);
            } else {
                console.error("Data structure is not as expected:", data);
            }
        } else {
            console.error("Fetched data or its structure is not as expected:", store.faculty.fetchedStudentsAttendence);
        }
    }, [store.faculty.fetchedStudentsAttendence]);

    const dailyReportData = store.faculty.fetchedDailyReport?.dailyReport || [];
    console.log(dailyReportData)


    return (
        <div>
            {store.faculty.isAuthenticated ? <>
                <div className="container-fluid p-0">
                    <div className="d-flex">
                        <div className="print-helper">
                            <FacultyHomeHelper />
                        </div>
                        <div className="mx-1 w-100 ">
                            <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="/logo192.png" width={'50px'} alt="" />Student Attendence</h3>
                                <button onClick={() => window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <div className="col d-md-flex align-items-center justify-content-between ">
                                <form
                                    className="d-md-flex align-items-center justify-content-start"
                                    noValidate
                                    onSubmit={formHandler}
                                >
                                    <div className="form-group mx-2 ">
                                        <label htmlFor="yearId">Year</label>
                                        <select
                                            onChange={(e) => setYear(e.target.value)}
                                            className={classnames('form-control', {
                                                'is-invalid': error.year
                                            })}
                                            id="yearId"
                                        >
                                            <option>Select</option>
                                            <option value="I">1</option>
                                            <option value="II">2</option>
                                            <option value="III">3</option>
                                            <option value="IV">4</option>
                                        </select>
                                        {error.year && (
                                            <div className="invalid-feedback">{error.year}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2 ">
                                        <label htmlFor="sectionId">Section</label>
                                        <select
                                            onChange={(e) => {
                                                setSection(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section
                                            })}
                                            id="sectionId"
                                        >
                                            <option>Select</option>
                                            <option value="A">A</option>
                                            <option value="B">B</option>
                                            <option value="C">C</option>
                                            <option value="D">D</option>
                                        </select>
                                        {error.section && (
                                            <div className="invalid-feedback">{error.section}</div>
                                        )}
                                    </div>
                                    <div className="form-group mx-2">
                                        <label htmlFor="semesterId">Semester</label>
                                        <select
                                            onChange={(e) => {
                                                setSemester(e.target.value);
                                            }}
                                            className={classnames('form-control', {
                                                'is-invalid': error.section
                                            })}
                                            id="semesterId"
                                        >
                                            <option>Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                        </select>
                                        {error.semester && (
                                            <div className="invalid-feedback">{error.semester}</div>
                                        )}
                                    </div>

                                    <div className="mt-3 position-relative">
                                        {!isLoading && (
                                            <button
                                                type="submit"
                                                className="btn btn-info btn-block print-helper"
                                            >
                                                <img
                                                    src="/image/search.svg"
                                                    className="mb-1"
                                                    alt=""
                                                />{' '}
                                                Search
                                                <span className="badge badge-warning position-absolute top-0 end-0">
                                                    {store.faculty.fetchedStudents.length}
                                                </span>
                                            </button>
                                        )}
                                        {isLoading && (
                                            <div
                                                className="spinner-border text-primary"
                                                role="status"
                                            >
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        )}
                                    </div>

                                </form>
                                <div>
                                    <button className='btn btn-success print-helper m-2 ' > <Link to="/addAttendenceFaculty" className='text-light'> <img src="/image/add.svg" alt="" className='m-1' />Mark Attendence</Link></button><br />
                                    <button className='btn btn-success print-helper m-2' > <Link to="/addDailyReportFaculty" className='text-light'> <img src="/image/add.svg" alt="" className='m-1' />Add Daily Report</Link></button>
                                </div>

                            </div>
                            <div className="row justify-content-center m-0">
                                <div className="col">
                                    <form className="d-md-flex align-items-center justify-content-start" onSubmit={secondFormHandler}>
                                        <div className="form-group mx-2">
                                            <label htmlFor="semesterId">Date</label> <br />
                                            <input type="date" onChange={(e) => {
                                                setDate(e.target.value);
                                            }}
                                                className={classnames('form-control', {
                                                    'is-invalid': error.section
                                                })}
                                                id="sectionId" />
                                            {error.semester && (
                                                <div className="invalid-feedback">{error.semester}</div>
                                            )}
                                        </div>
                                        <div className="mt-3">
                                            {!isLoading2 && (
                                                <button
                                                    type="submit"
                                                    className="btn btn-info btn-block print-helper "
                                                >
                                                    <img
                                                        src="/image/search.svg"
                                                        className="mb-1"
                                                        alt=""
                                                    />{' '}
                                                    Show Grid
                                                </button>
                                            )}
                                            {isLoading2 && (
                                                <div
                                                    className="spinner-border text-primary"
                                                    role="status"
                                                >
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                    <div>
                                    <table className="table table-bordered table-striped">
        <thead className="thead-dark">
            <tr>
                <th scope="col">Period</th>
                <th scope="col">Subject Name</th>
                <th scope="col">Faculty</th>
                <th scope="col">Portion Covered</th>
                <th scope="col">Unit</th>
                <th scope="col">Present Count</th>
                <th scope="col">Absent Count</th>
            </tr>
        </thead>
        <tbody>
            {dailyReportData.length > 0 ? (
                dailyReportData.map((report, reportIndex) => (
                    report.periods.map((period, periodIndex) => (
                        <tr key={`${reportIndex}-${periodIndex}`}>
                            <td>{period.period}</td>
                            <td>{period.subjectName}</td>
                            <td>{period.faculty}</td>
                            <td>{period.portionCovered}</td>
                            <td>{period.unit}</td>
                            <td>{totalPresent}</td>
                            <td>{totalAbsents}</td>
                        </tr>
                    ))
                ))
            ) : (
                <tr>
                    <td colSpan="7" className="text-center">No data available</td>
                </tr>
            )}
        </tbody>
    </table>

                                        <table className="table table-bordered table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">S.NO</th>
                                                    <th scope="col">Registration Number</th>
                                                    <th scope="col">Student Name</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(store.faculty.fetchedStudentsAttendence.data) &&
                                                    store.faculty.fetchedStudentsAttendence.data.map((obj, index) => {
                                                        const { departments } = obj;

                                                        // Flatten the nested structure to get a list of students
                                                        const studentsList = departments.flatMap((department) =>
                                                            department.years.flatMap((year) =>
                                                                year.semesters.flatMap((semester) =>
                                                                    semester.sections.flatMap((section) => section.students)
                                                                )
                                                            )
                                                        );

                                                        return studentsList.map((student, studentIndex) => {
                                                            const { student: studentId, status, reasons } = student;

                                                            // Find the student in fetchedStudents array based on the student ID
                                                            const studentInfo = store.faculty.fetchedStudents.find(
                                                                (student) => student._id === studentId
                                                            );

                                                            // Check if studentInfo is available before rendering the row
                                                            if (studentInfo) {
                                                                const getStudentInfoField = (field) => studentInfo[field];

                                                                const key = `${studentId}-${studentIndex}`;

                                                                return (
                                                                    <tr key={key}>
                                                                        <td>{studentIndex + 1}</td>
                                                                        <td>{getStudentInfoField('registrationNumber')}</td>
                                                                        <td>{getStudentInfoField('name')}</td>
                                                                        <td>
                                                                            {status === 'Present' ? (
                                                                                <span className="badge badge-success">Present</span>
                                                                            ) : (
                                                                                <span className="badge badge-danger">Absent</span>
                                                                            )}
                                                                        </td>
                                                                        <td>{reasons}</td>
                                                                    </tr>
                                                                );
                                                            } else {
                                                                // Return null or an empty fragment if studentInfo is not available
                                                                return null;
                                                            }
                                                        });
                                                    })}

                                            </tbody>


                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </> : (history.push('/'))}

        </div>
    )
}

export default AttendenceFaculty
